export default {
  'data': [
    {
      'numberPlate': '浙A123131', //车牌
      'paymentStatus': '已付款', //付款状态
      'orderTitle': '惠动全城，只为口碑与宣传', //订单文本
      'worth': '8.80', //金额
      'quantity': '1', //数量
      'orderTime': '2019/7/9 15:10:31', //成交时间
    },
    {
      'numberPlate': '浙B86784',
      'paymentStatus': '已付款，拼团失败',
      'orderTitle': '美孚10004升套餐【两次保养】',
      'worth': '0.32',
      'quantity': '90',
      'orderTime': '2019/7/9 15:10:31'
    },
    {
      'numberPlate': '沪A86784',
      'paymentStatus': '已退款',
      'orderTitle': '美孚10004升套餐【两次保养】',
      'worth': '5.80',
      'quantity': '11',
      'orderTime': '2019/7/9 15:10:31'
    }
  ]
}
